import React, { useState } from 'react';
import { stringify } from 'qs';
import { Box, Button, Text, useSnackbar } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { EXISTING_PLAN_ERR_MSG } from 'components/shop/MobilePlans/constants/changePlan.constants';
import { useChangePlanDetails } from 'components/shop/MobilePlans/providers';
import { ChangePlanActionTypes } from 'components/shop/MobilePlans/reducer/changePlan.reducer';
import ChoiceBoxSelector from '../ChoiceBoxSelector';

const ChangePlanLineSelectionContent = () => {
  const [selectedLine, setSelectedLine] = useState('');
  const { userInfoUpdate, dispatch } = useChangePlanDetails();
  const { showSnackbar } = useSnackbar();
  const { redirect, eligibleLines, accounts, selectedAccount } = userInfoUpdate;

  const handleClick = () => {
    if (redirect && selectedLine) {
      const { path, planId } = redirect;
      if (
        planId ===
        eligibleLines?.find((line) => line.lineNumber === selectedLine)?.offerId
      ) {
        showSnackbar({
          text: EXISTING_PLAN_ERR_MSG,
          variant: 'error',
        });
      } else {
        const redirectLink = `${path}?${stringify(
          {
            lineNumber: selectedLine,
            action: 'changePlan',
            offerId: planId,
            tab: 'endless_plans',
          },
          { arrayFormat: 'comma' },
        )}`;
        window.location.assign(redirectLink);
      }
    }
  };

  const handleAccountChange = () => {
    dispatch({
      type: ChangePlanActionTypes.SetChangeAccount,
    });
  };

  const items = eligibleLines
    ?.filter((lines) => lines?.accountNumber === selectedAccount)
    .map(({ lineNumber, offerName }) => ({
      id: lineNumber,
      label: `${lineNumber}`,
      subLabel: `${offerName}`,
    }))!;

  const userAccountData = accounts?.find(
    (account) => account.accountNumber === selectedAccount,
  );

  return (
    <Box pt="s4">
      <Text variant="headingS" mb="s4">
        Your plans
      </Text>
      <Text variant="bodySMedium" mb="s3">
        Choose the plan you would like to replace
      </Text>
      <Box mb="s3">
        <Text variant="bodyMDemi">
          {userAccountData?.firstName}&nbsp;{userAccountData?.lastName}
        </Text>
        <Text variant="bodySMedium">Account number : #{selectedAccount}</Text>
        {accounts && accounts?.length > 1 ? (
          <Button variant="textbutton" onClick={handleAccountChange}>
            Change account
          </Button>
        ) : null}
      </Box>
      <Text variant="bodySDemi">Your plans</Text>
      <LinkRegion isNotTracked>
        <ChoiceBoxSelector
          items={items}
          selectedItem={selectedLine}
          setSelectedItem={setSelectedLine}
        />
        <LinkRegion regionId="productDetails.selectAccount">
          <Button
            variant="primary"
            fullWidth
            onClick={handleClick}
            disabled={!selectedLine}
            mb={'s2'}
          >
            Change this plan
          </Button>
        </LinkRegion>
      </LinkRegion>
    </Box>
  );
};

export default ChangePlanLineSelectionContent;
